import { createSelector } from 'reselect';
import { selectCurrentFlyerId } from './flyers.selectors';

export const selectViewer = (state) => state.viewer;
export const selectViewerZoomed = (state) => state.viewer.zoomed;
export const selectViewerNavigatorOpen = (state) => state.viewer.navigatorOpen;
export const selectViewerInitialized = (state) => state.viewer.initialized;
export const selectViewerFlyerId = (state) => state.viewer.flyerId;
export const selectViewerNumberOfPages = (state) => state.viewer.numberOfPages;
export const selectViewerViewedPages = (state) => state.viewer.viewedPages;
export const selectViewerCurrentPages = (state) => state.viewer.currentPages;
export const selectViewerDirection = (state) => state.viewer.direction;

export const selectCurrentFlyerPages = (state) => {
  const flyerID = selectCurrentFlyerId(state);
  const { viewer: { flyerPages = {} } = {} } = state;
  return flyerPages[flyerID] || null;
};

export const selectViewerExtrasBase = (state) => state.viewer.extrasBase;
export const selectViewerCurrentSlide = (state) => state.viewer.slide;
export const selectViewerCurrentSlideHasExtras = createSelector(selectViewerCurrentSlide, selectViewerExtrasBase, (slide, extrasBase) =>
  extrasBase.pageNumbers.includes(slide + 1)
);
